import type { AxiosRequestConfig } from "axios";
import api from "../utils/api";

export interface QueryFetchContext {
  signal?: AbortSignal;
}

export async function getJson<T>(
  url: string,
  params?: Record<string, unknown>,
  ctx?: QueryFetchContext,
  config?: AxiosRequestConfig,
): Promise<T> {
  const { data } = await api.get<T>(url, {
    ...config,
    params: { ...config?.params, ...params },
    signal: ctx?.signal,
  });
  return data;
}
